import styled from 'styled-components';
import { Checkbox as AntdCheckbox, ConfigProvider } from 'antd';
import { CheckboxProps } from 'antd/lib';

const CheckboxV2 = ({ children, ...props }: CheckboxProps & { children?: React.ReactNode }) => {
    return (
        <ConfigProvider
            theme={{
                components: {
                    Checkbox: {
                        colorPrimaryHover: '#2D6772',
                        colorPrimary: '#2D6772',
                        borderRadiusSM: 3,
                        controlInteractiveSize: 32,
                    },
                },
            }}
        >
            <CheckboxV2Styled {...props} >
                <span className="checkbox-label-text">{children}</span>
            </CheckboxV2Styled>
        </ConfigProvider>
    );
};

export default CheckboxV2;

const CheckboxV2Styled = styled(AntdCheckbox)`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  justify-content: center;
  align-items: center;

  .checkbox-label-text {
    color: #1D2129;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px; /* 166.667% */
    text-transform: capitalize;
  }
  .ant-checkbox-inner:after {
    top: 49%
  }
  &.ant-checkbox-wrapper {
    flex-direction: column;
  }
  &.ant-checkbox-wrapper:after {
    display: none;
  }
  &.ant-checkbox-wrapper-checked {
  background: #F2FEFF;
    .checkbox-label-text {
      color: #2D6772 !important;
    }
  }
`;